import { NotificationsService } from 'src/app/core/services/notifications/notifications.service';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AvatarModule } from 'primeng/avatar';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { RequestInterceptor } from './core/auth/request.interceptor';
import { LoaderService } from './core/services/loader.service';
import { DatePipe } from '@angular/common';
import { ConfirmationService } from 'primeng/api';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    AvatarModule,
    SharedModule,
  ],
  providers: [DatePipe, {
    provide: HTTP_INTERCEPTORS,
    useClass: RequestInterceptor,
    multi: true
  }, NotificationsService, LoaderService, ConfirmationService],
  bootstrap: [AppComponent],
})
export class AppModule { }
